import { connect } from 'react-redux';
import { Instances } from '../../../../constants';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { IStateType } from '../../../../store/models/root.interface';
// import {
// 	makeSelectInProgress,
// 	removeObject, requestObject,
// } from '../../../../store/Object';
import {
	closeSideBar,
	getParams,
} from '../../../../store/sidebar';
import PayloadModal, { DispatchPropsType, MapStatePropsType } from '../PayloadModal';
import {
	makeSelectCount,
	makeSelectFilters,
	makeSelectGlobalCount,
	makeSelectObjectsArray,
	makeSelectOffset, makeSelectInProgress, makeSelectPaginationInProgress, requestObjects, removeObjects,
} from "../../../../store/Objects";

const mapStateToProps = (state: IStateType) => {
	const params = getParams(state);
	const selectPayloadData = makeSelectObjectsArray(Instances.StepwisePayload);
	const selectPage = makeSelectOffset(Instances.StepwisePayload);
	const selectTotal = makeSelectCount(Instances.StepwisePayload);
	const selectInProgress = makeSelectInProgress(Instances.StepwisePayload);
	const appliedFilters = makeSelectFilters(Instances.StepwisePayload);
	const globalTotal = makeSelectGlobalCount(Instances.StepwisePayload);
	const selectInPaginationProgress = makeSelectPaginationInProgress(Instances.StepwisePayload);
	return (state: IStateType) => ({
		params,
		payloadData : selectPayloadData(state),
		page: selectPage(state),
		total: selectTotal(state) || 0,
		inProgress: selectInProgress(state) || false,
		appliedFilters: appliedFilters(state),
		globalTotal: globalTotal(state),
		paginationInProgress: selectInPaginationProgress(state) || false
	});
};
const mapDispatchToProps = {
	// loadPayloadData : (filters?:Record<string, any>) => requestObject(Instances.StepwisePayload,filters),
	loadPayloadData : (
		filters?: Record<string, any>,
		property?:string,
		searchTerm?:string,
	) => requestObjects(
		Instances.StepwisePayload,
		filters,
		{property,searchTerm}
	),
	onClose: () => closeSideBar([removeObjects(Instances.StepwisePayload)])
};

export default connect<
	MapStatePropsType,
	DispatchPropsType,
	unknown,
	IStateType
>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(PayloadModal));
